import React from 'react';
import { shape, string, arrayOf, func } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { RatingMeter, Typography } from '@one-thd/sui-atomic-components';
import { SelectableVarientRadio } from '../SelectableVarientRadio';
import { updatePricingLaundryProduct } from '../../utils/product-utils';
import { NONE_VALUE } from '../../constants/index';

export const LaundryProductDetails = ({
  product,
  onSwapVariant
}) => {
  const {
    itemId, selectableVariants, category, selectedVariant
  } = product || {};
  const { averageRating, totalReviews } = product?.reviews?.ratingsReviews || {};
  const { brandName, productLabel } = product?.identifiers || {};

  return (
    <div data-testid="product-details" className="sui-flex sui-flex-col sui-items-start">
      <div className="sui-min-h-7">
        {selectedVariant === NONE_VALUE || (
          <Price
            itemId={itemId}
            product={updatePricingLaundryProduct(product)}
            large={false}
          />
        )}
      </div>
      <RatingMeter
        value={averageRating}
        label={`(${totalReviews})`}
        edge="start"
        RatingProps={{
          color: 'brand'
        }}
        data-testid="rating-button"
      />
      <div>
        <Typography
          data-testid="pod-brandname"
          variant="body-sm"
          weight="bold"
        >
          {brandName}
        </Typography>
        <Typography
          data-testid="pod-productlabel"
          variant="body-sm"
          lineClamp="2"
        >
          {productLabel}
        </Typography>
      </div>
      {
        selectableVariants?.length > 1 && (
          <SelectableVarientRadio
            selectableVarient={selectableVariants}
            handleChange={onSwapVariant}
            value={selectedVariant}
            productCategory={category}
          />
        )
      }
    </div>
  );
};

LaundryProductDetails.displayName = 'CustomProductPod';

LaundryProductDetails.propTypes = {
  product: shape({
    itemId: string.isRequired,
    selectableVariants: arrayOf(shape({
      name: string.isRequired,
      value: string.isRequired
    })).isRequired,
    category: string.isRequired,
    pricing: shape({}).isRequired,
    reviews: shape({
      ratingsReviews: shape({
        averageRating: string,
        totalReviews: string
      })
    }).isRequired,
    identifiers: shape({
      productLabel: string,
      brandName: string
    }).isRequired
  }).isRequired,
  onSwapVariant: func.isRequired
};

LaundryProductDetails.dataModel = extend(
  Price
);
